import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { jamarekObj } from 'src/app/models/jamarekObj';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { SweetAlertService } from 'src/services/sweetAlertService';
import jwt_decode from "jwt-decode";

@Component({
  selector: 'app-jamarek-transfer-quantity',
  templateUrl: './jamarek-transfer-quantity.component.html',
  styleUrls: ['./jamarek-transfer-quantity.component.css']
})
export class JamarekTransferQuantityComponent {

  form!: FormGroup;
  statisticalUnits:any[]=[];
  units:any[][] = [];
  taxUnits:any[][] = [];
  carbonCopyId:string|undefined;
  hideadditionalCode=false;
  formSubmited:boolean=false;
  isLoading=true;
  
  firstTime=true;
  showSaveBtn=true;  
  showLicenseError=false;

  editMode:boolean=false;

  public exemptAssetsList:any[]=[];
  idsZero:boolean=false;
  showSearchBtn=true;
  mainPath = "" // قراءة القيمة من environment

  showJamarek=true;
  showTax=true;
  formType:string="1";
  TaxNumber:string|undefined;
  licenseId:string|undefined;
  isEmployee=false;
  applicationNumber?:string|undefined="0";
  token:string="";
  employeeId:string|undefined;
  gamarekCount:number=0;
  taxCount:number=0;
  // editHsCode=true;
  // editQuantity=true;

  getExemptAssetsList(){


    var request=this.apiService.get("Moin/GetFindings",`${environment.govnet}`);

    request.subscribe(response=>{
      var data=response.data.list as any[];

      var newList= data.map(item=>{

        var value=  item.value as string;

        var newValue=value.substring(0,50);

        return  {
          key:item.key,
          value:newValue,
        }

      });

      this.exemptAssetsList=newList;

    });
  }

  constructor(private fb: FormBuilder,private apiService:ApiService,private authService:AuthService,
    private route: ActivatedRoute,private alertService:SweetAlertService) {
      this.mainPath= environment.MainPath;

    this.token= this.route.snapshot.queryParamMap.get('Token')!;

    var token = this.route.snapshot.queryParamMap.get('Token')!;

    var decoded = jwt_decode(token) as any;

    this.employeeId= decoded.sub;

    this.getExemptAssetsList();
    this.fillStaticUnit();

    if(this.route.snapshot.queryParams['Token'] && this.route.snapshot.queryParams['Carponcopyid']){

      this.carbonCopyId= this.route.snapshot.queryParamMap.get('Carponcopyid')!;

      this.formType= this.route.snapshot.queryParamMap.get('formType')!;
      this.licenseId= this.route.snapshot.queryParamMap.get('licenseId')!;
      this.applicationNumber = this.route.snapshot.queryParamMap.get('ApplicationNumber')??"0";

      if(this.formType=="2"){

        var showingType = this.route.snapshot.queryParamMap.get('show')!;

        if(showingType=="jamarek"){

          this.showJamarek=true;
          this.showTax=false;

        }else if(showingType=="tax"){

          this.showJamarek=false;
          this.showTax=true;

        }


      }

      var TaxNumber = this.route.snapshot.queryParamMap.get('TaxNumber')!;

      this.TaxNumber=TaxNumber;

      this.checkValidty();

      this.form = this.fb.group({
        taxNumber:[TaxNumber, Validators.required],
        licenseId:[this.licenseId, Validators.required],
        formItems: this.fb.array([]),
        taxItems: this.fb.array([]),
      });

      this.isExistOldApplication(this.carbonCopyId,this.licenseId);




      // var token = this.route.snapshot.queryParamMap.get('Token')!;

      // var decoded = jwt_decode(token) as any;

      // if(decoded.role!="CONSUMER"){
      //   this.isEmployee=true;
      // }
    

    }else{
      location.href="/"+this.mainPath+"/Dashboard";
    }

  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  calculateCounter(){

    this.gamarekCount=0;
    this.taxCount=0;

    this.Items.controls.map(item=>{

      if(item.get('totalPrice')?.value!=0 &&item.get('quantity')?.value!=0 ){
        this.gamarekCount+= item.get('totalPrice')?.value* item.get('quantity')?.value;
      }

    });

    this.TaxItems.controls.map(item=>{

      if(item.get('totalPrice')?.value!=0 &&item.get('quantity')?.value!=0 ){
        this.taxCount+= item.get('totalPrice')?.value* item.get('quantity')?.value;
      }

    });


  }

  isExistOldApplication(currentCarbonId:string,licenceId:string){


    var request = this.apiService.get(`Moin/IsExistOldApplication?cureentCarbonId=${currentCarbonId}&licenceId=${licenceId}`,environment.govnet,undefined,this.token);

    request.subscribe(response=>{

      var result = response.data.value as boolean;

      this.idsZero= !result;

      this.fillApplicant(this.carbonCopyId!,true);

    });

  }

  fillApplicant(carbonId:string,search:boolean){

    if(search)
    {
      if(this.Items.length>0){
        this.clearFormArray(this.Items);
      }
      
      if(this.TaxItems.length>0){
        this.clearFormArray(this.TaxItems);
      }
    }

    if(carbonId=="" || carbonId==null){
      this.showLicenseError=true;
      return;
    }else{
      this.showLicenseError=false;

    }

    this.isLoading=true;

    var request=this.apiService.get('Moin/GetJamarekTaxApplicantData?licenseId='+ (this.idsZero?this.licenseId:this.carbonCopyId),`${environment.govnet}`);

    request.subscribe(response=>{

  
      var jamarekImtems=response.data.jamarek as any[];
      var taxImtems=response.data.tax as any[];

      

      // if(response.oldCarbonId!=null){
      //   this.form.get('licenseId')?.setValue(response.oldCarbonId);
      // }

      if(this.idsZero){
        this.fillTax();
        this.isLoading=false;
      }else{
        
        if(taxImtems.length>0){
  
          taxImtems.map((item,index)=>{
  
            var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,item.description,item.credits,item.note);
            var form= this.generateItem(obj);
            // this.searchEnquiry(item.searchKeyword,index);
            this.addTaxItemWithValue(form);
    
          });
        }

      }


      if(jamarekImtems.length>0){

        this.form.get('taxNumber')?.setValue(jamarekImtems[0].taxNumber);

        jamarekImtems.map((item,index)=>{

          var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,item.description,item.credits,item.note);
          var form= this.generateItem(obj);
          this.searchEnquiry(item.searchKeyword,index);
          this.addItemWithValue(form);

        });

        this.isLoading=false;

        
        //this.getTaxItemsFromTax();

      }else{
        this.isLoading=false;
      }

      this.calculateCounter();

    });



  }

  fillTax(){

    var request = this.apiService.get(`Moin/GetInvestmentISTDInfo?Book_No=${this.form?.get('licenseId')?.value}&TXP_No=${this.TaxNumber}`,environment.govnet,undefined,this.token);

    request.subscribe(response=>{

      var list=response.data as any[];

      if(list.length>0){

        list.map(item=>{

          var obj=new jamarekObj(0,item.iteM_DESC,'1',item.iteM_QTY,'',0,'1',true,0,'','','');
          var form= this.generateItem(obj);
          this.addTaxItemWithValue(form);  
          this.isLoading=false;

        });

      }

    });

  }


  // getTaxItemsFromTax(){
  //   var request=this.apiService.customGet('https://investment.dev.test.jo',`api/Customs/GetInvestmentISTDInfo?Book_No=${this.carbonCopyId}&TXP_No=${this.form.get('taxNumber')?.value}`);

  //   request.subscribe(response=>{
  //     var list=response as any[];

  //     list.map(item=>{
  //       var obj=new jamarekObj(item.id,item.iteM_DESC,'1',item.iteM_QTY,'1',item.additionalCode,'1',true,0,'','','');
  //       var form= this.generateItem(obj);
  //       this.addTaxItemWithValue(form);
  //     });

  //   });

  // }

  checkValidty(){

    var request=this.apiService.get(`Moin/GetEditFormByConsumerStatus?carbonId=${this.carbonCopyId}`,`${environment.govnet}`,undefined,this.token);

    request.subscribe(response=>{

      this.isLoading=false;

      if(response.data.value==true){
        
        this.showSaveBtn=false;
        
      }
    });

  }


  generateItem(data?: {
    id?: number;
    unitName?: string;
    unitId?: string;
    quantity?: string;
    exemptAssets?: string;
    staticUnit?: string;
    additionalCode?: number;
    hsCode?: boolean;
    fromDb:boolean;
    totalPrice: number;
    description: string;
    note: string;
    credits: string;
  }): FormGroup {

    return this.fb.group({
      id: [data?.id ||0],
      unitName: [data?.unitName || '', Validators.required],
      unitId: [data?.unitId || '', [Validators.required]],
      quantity: [data?.quantity || '1', [Validators.min(1),Validators.required]],
      exemptAssets: [ data?.exemptAssets],
      staticUnit: [data?.staticUnit || '', Validators.required],
      additionalCode: [data?.additionalCode?.toString() !="" ? data?.additionalCode : ((data?.exemptAssets=="")? '':'708') , Validators.required ],
      hsCode: [data?.unitId || ''],
      fromDb: data?.fromDb??false,
      totalPrice: [data?.totalPrice || '1', [Validators.min(1),Validators.required]],
      description: [data?.description || '',Validators.required],
      note: [data?.note || ''],
      credits: [data?.credits || ''],
    });
    
  }

  get Items() {
    return this.form.get('formItems') as FormArray;
  }

  get TaxItems() {
    return this.form.get('taxItems') as FormArray;
  }

  addItem() {
    this.Items.push(this.generateItem());
  }

  addItemWithValue(data:FormGroup) {
    this.Items.push(data);
  }


  removeJamarek(index: number) {
    this.Items.removeAt(index);
  }

  removeTax(index: number) {
    this.TaxItems.removeAt(index);
  }

  // addTaxItem() {
  //   this.TaxItems.push(this.generateItem({hsCode:false,unitId:"1",fromDb:false,totalPrice:0,credits:'',description:''}));
  // }

  addTaxItemWithValue(data:FormGroup) {
    this.TaxItems.push(data);
  }

  
  onSubmit() {

    this.formSubmited=true;

    if(this.form.valid){

      this.formSubmited=false;
      //this.showSaveBtn=false;

      var gamarekExemptionReqest:any[]=[];

      var taxExemptionReqest:any[]=[];

      let items = this.Items;
      let taxItems = this.TaxItems;

      items.controls.forEach((control, index) => {

        let searchText= $(`#unitId-${index} option:selected`).text();

        var data={
          "id": this.idsZero==false ? control.get('id')?.value : 0 ,
          "ssCode": control.get('unitId')?.value,
          "quantity": control.get('quantity')?.value,
          "statisticalUnit": control.get('staticUnit')?.value,
          "exemptAssets": control.get('exemptAssets')?.value,
          "additionalCode":control.get('additionalCode')?.value ,
          "description":control.get('description')?.value ,
          "credits":String(control.get('credits')?.value) ,
          "searchKeyword": searchText,
          "totalPrice": control.get('totalPrice')?.value,
          "note":control.get('note')?.value ,

        };

        gamarekExemptionReqest.push(data);
      });

      taxItems.controls.forEach((control, index) => {

        var data={
          "id": this.idsZero==false ? control.get('id')?.value : 0 ,
          "ssCode": control.get('unitId')?.value,
          "quantity": control.get('quantity')?.value,
          "statisticalUnit": control.get('staticUnit')?.value,
          "exemptAssets": control.get('exemptAssets')?.value,
          "description":control.get('description')?.value ,
          "additionalCode":control.get('additionalCode')?.value ,
          "searchKeyword": control.get('unitName')?.value,
          "totalPrice": control.get('totalPrice')?.value,
          "credits":String(control.get('credits')?.value) ,
          "note":control.get('note')?.value ,

        };

        taxExemptionReqest.push(data);
      });

      var body={
        "model":{
          "carponcopyid": this.carbonCopyId,
          "taxNumber": this.form.get('taxNumber')?.value,
          "oldCarbonId": this.form.get('licenseId')?.value,
          "userId": this.employeeId,
          "jamarekItems": gamarekExemptionReqest,
          "taxItems":taxExemptionReqest,
          "userType":"2",
          "applicationNumber":this.applicationNumber,
        }
      }

      var request=this.apiService.post('Moin/SubmitExemptionForm',body,`${environment.govnet}`,undefined,this.token);;

        request.subscribe(response=>{
          if(response){
            if(response.data.value==true){
              
              this.alertService.ShowAlert('success',' تم الحفظ بنجاح');
            }else{
              this.showSaveBtn=true;
            }
          }
        });



    }else{
      console.log(this.form);
    }
  }

  


  fillStaticUnit(){

    var request= this.apiService.get('Moin/GetStatisticalUnits' , `${environment.govnet}`,undefined,this.token);
    request.subscribe(response=>{
      var list=response.data.list;
      this.statisticalUnits=list;
    });

  }

  async getUnits(event:Event, index: number){
    
    const inputElement = event.target as HTMLInputElement; // Type assertion
    const text = inputElement.value;


    await this.searchEnquiry(text, index);

  }



  private searchEnquiry(text: string, index: number,refresh:boolean=false) {

    if(refresh){
      this.isLoading=true;
    }

    var request = this.apiService.get('Moin/GeneralEnquiry?description=' + text, `${environment.govnet}`,undefined,this.token);;

    request.subscribe(response => {

      this.isLoading=false;

      this.units[index] = response.data.list as any[];
    });
  }


  onUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;

    this.Items.controls.map(control=>{

      if(control.get('hsCode')?.value==selectedUnitId){

          this.alertService.ShowAlert('error','لا يمكن تكرار نفس العنصر');

          this.removeJamarek(index);

          return;

      }

    });
  
    const selectedUnit = this.units[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('formItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  onTaxUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;
  
    const selectedUnit = this.taxUnits[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('taxItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  


}

